module.exports = __webpack_public_path__ + "img/mpQrCode.da9ad99d.png";